@if(isDisabled && showOnlyValueWhenDisabled)
{
<div class="flex items-center" [ngClass]="boxHeight">
    <p class="text-sm font-medium text-black">{{ formatDateValue() }}</p>
</div>
}
@else {
<div class="card flex flex-col justify-content-center w-full" [ngClass]="autoMarginTop">
    <label [for]="inputId" class="mb-2 text-sm font-medium text-black" *ngIf="labelText">
        {{ labelText }}
    </label>

    <div class="relative flex items-center rounded-[10px] w-full focus:ring-2 focus:ring-primary focus:outline-none hover:cursor-text bg-[#FFFFFF]"
        (click)="openCalendar()"
        [ngClass]="[boxHeight, errorMessage ? 'border-error border-2' : 'border border-border']">
        <p-calendar #calendarRef class="w-full h-full p-2" [id]="inputId" [(ngModel)]="dateValue"
            [dateFormat]="dateFormat" [placeholder]="placeholder" [disabled]="isDisabled" [appendTo]="appendTo"
            [attr.aria-invalid]="errorMessage ? 'true' : null"
            [attr.aria-describedby]="errorMessage ? inputId + '-error' : null" (onClose)="onDateChange()"
            (ngModelChange)="onDateChange()" (onInput)="onDateChange()" />
    </div>

    <div *ngIf="errorMessage" [id]="inputId + '-error'" class="flex items-center text-error mt-2 text-sm">
        <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}"
            class="w-5 h-5" />
        <p class="ml-1">{{ errorMessage }}</p>
    </div>
</div>
}